import {
  BodyText,
  Button,
  Checkbox,
  ModalFooter,
  ModalHeader,
  toast,
} from '@postscript/components';
import { useGlobalModal } from 'components/GlobalModal/globalModal';
import { useState } from 'react';
import styled from 'styled-components';
import { useSkipTFNValidation } from './hooks/useTFNVerification';

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  margin-top: var(--spacing-3);
`;

export interface TFNVerificationSubmissionModalProps {
  title?: string;
  bodyText?: string;
  cancelButtonLabel?: string;
}

export default function TFNVerificationSubmissionModal({
  title = 'Retry TFN verification',
  bodyText = "Your TFN verification request couldn't be submitted. Please verify the following information before trying again.",
  cancelButtonLabel = 'Close',
}: TFNVerificationSubmissionModalProps): JSX.Element {
  const [customDomain, setCustomDomain] = useState(false);
  const [passwordProtected, setPasswordProtected] = useState(false);
  const [multipleProducts, setMultipleProducts] = useState(false);
  const [businessAddress, setBusinessAddress] = useState(false);
  const { hideModal } = useGlobalModal();
  const { mutateAsync: skipTFNValidation } = useSkipTFNValidation();

  const allConfirmed =
    customDomain && passwordProtected && multipleProducts && businessAddress;

  return (
    <>
      <ModalHeader onCancel={hideModal}>{title}</ModalHeader>
      <BodyText color="var(--text-color)" size="small">
        {bodyText}
      </BodyText>
      <CheckboxContainer>
        <Checkbox
          id="custom-domain"
          name="custom-domain"
          label="Custom domain is set up correctly with Shopify."
          checked={customDomain}
          onChange={() => setCustomDomain(!customDomain)}
        />
        <Checkbox
          id="password-protected"
          name="password-protected"
          label="Shop is not password protected."
          checked={passwordProtected}
          onChange={() => setPasswordProtected(!passwordProtected)}
        />
        <Checkbox
          id="multiple-products"
          name="multiple-products"
          label="Catalog has multiple products available."
          checked={multipleProducts}
          onChange={() => setMultipleProducts(!multipleProducts)}
        />
        <Checkbox
          id="business-address"
          name="business-address"
          label="Business address is complete and correct."
          checked={businessAddress}
          onChange={() => setBusinessAddress(!businessAddress)}
        />
      </CheckboxContainer>
      <ModalFooter>
        <>
          <Button
            disabled={!allConfirmed}
            onClick={async () => {
              await skipTFNValidation();
              toast.success('Submitted TFN verification request.');
              hideModal();
            }}
            variant="primary"
          >
            Submit Request
          </Button>
          <Button variant="text" onClick={() => hideModal()}>
            {cancelButtonLabel}
          </Button>
        </>
      </ModalFooter>
    </>
  );
}
